// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { PostAiAgentConfigsCozeBody, BaseResponsestring } from '../../types';

/**
 * 保存coze授权信息
 *
 * @export
 * @tags Coze智能体
 * @link [POST] /aiAgentConfigs/coze
 */
export function postAiAgentConfigsCoze(
    data: PostAiAgentConfigsCozeBody
): Promise<BaseResponsestring>;
export function postAiAgentConfigsCoze(
    data: PostAiAgentConfigsCozeBody,
    options: ApiOptions<never, never>
): Promise<BaseResponsestring>;
export function postAiAgentConfigsCoze(
    data: PostAiAgentConfigsCozeBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponsestring> {
    return request<PostAiAgentConfigsCozeBody, never, never>('/aiAgentConfigs/coze', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postAiAgentConfigsCoze',
    });
}

export const meta = [{ tags: ['Coze智能体'], path: '/aiAgentConfigs/coze', method: 'post' }];
